import { useState } from "react";
import { EmailDataRequest } from "../../types/empresa";
import { Editor } from "../UtilitiesComponents/Editor";
import CircularProgress from '@mui/joy/CircularProgress';
import { useSendEmailMutation } from "../../api/emailClientApi";

export function EmailEditor() {
 	const [email, setEmail] = useState<string>("")
 	const [subject, setSubject] = useState<string>("")
 	const [body, setBody] = useState<string>("")
    const [resetBody, setResetBody] = useState<boolean>(false);

    const [sendingEmail, setSendingEmail] = useState<boolean>(false);

    const [sendEmail, { isSuccess }] = useSendEmailMutation();

 	const handleSendEmail = async () => {
        try {
            setSendingEmail(true);

            const emailRequest: EmailDataRequest = {
                subject: subject,
                body: body,
                email: email
            };

            const response = await sendEmail(emailRequest).unwrap();
            
            setSendingEmail(false);
            setResetBody(true);
            setEmail("");
            setSubject("");

        } catch (error) {
            setSendingEmail(false);
        }
 	}

    return (
		<div className="bg-white border-2 border-t-0 border-gray-300 rounded-b-md">
            <div className="h-8 border-y flex items-center px-3 gap-2">
                <label className="text-gray-500 font-semibold">Para: </label>
                <input 
                    className="focus:outline-none w-full"
                    type="text" 
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}/>
            </div>

            <div className="h-8 border-y flex items-center px-3 gap-2">
                <label className="text-gray-500 font-semibold">Asunto: </label>
                <input 
                    className="focus:outline-none w-full"
                    type="text" 
                    value={subject}
                    onChange={(event) => setSubject(event.target.value)}/>
            </div>

            <Editor 
                setResetBody={setResetBody}
                resetBody={resetBody}
                body={body}
                setBody={setBody}/>

            <div className="border-t-2 border-gray-300 flex justify-end ">
                <div className="m-2">
                {sendingEmail 
                    ? <div className="w-[46px] mx-[6px]">
                        <CircularProgress variant="plain" color="success" sx={{
                            "--CircularProgress-size": "22px",
                            "--CircularProgress-progressThickness": "4px"
                        }}/>
                    </div>
                    :<button 
                        className="bg-green-800 h-fit rounded px-[6px] py-[4px]"
                        onClick={async () => await handleSendEmail()}>
                        <p className="text-white text-sm font-semibold">Enviar</p>
                    </button>
                }
                </div>
            </div>

        </div>
    );
}